import { useEffect, useState } from "react";

const STORAGE_KEY = "darkMode";

function getInitialDark() {
	return localStorage.getItem(STORAGE_KEY) === "true";
}

export default function useDarkMode() {
	const [isDark, setIsDark] = useState(getInitialDark);

	useEffect(() => {
		const html = document.documentElement;
		html.classList.toggle("dark-mode", isDark);
		html.style.colorScheme = isDark ? "dark" : "light";
		localStorage.setItem(STORAGE_KEY, isDark);
	}, [isDark]);

	return [isDark, setIsDark];
}
